export enum TasksOrderBy {
  CLIENT = 'customers.name',
  PROJECT = 'projects.name',
  NAME = 'name',
  DUE_DATE = 'due_date',
}
